// extracted by mini-css-extract-plugin
module.exports = {"container":"cL_x","video":"cL_cL","info":"cL_P","title":"cL_S","containerButton":"cL_jQ","button":"cL_cQ"};